import { render } from "./VendorsListView.vue?vue&type=template&id=35032d40"
import script from "./VendorsListView.vue?vue&type=script&lang=js"
export * from "./VendorsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__